export default __webpack_public_path__ + "static/lead-sp-b80abd82f25e439b1586bbf1695bdc14.svg";